import { render, staticRenderFns } from "./InoutDetails.vue?vue&type=template&id=7356a2cb&"
import script from "./InoutDetails.vue?vue&type=script&lang=js&"
export * from "./InoutDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports